import { render, staticRenderFns } from "./addressSort.vue?vue&type=template&id=cc34e5ec&scoped=true&"
import script from "./addressSort.vue?vue&type=script&lang=js&"
export * from "./addressSort.vue?vue&type=script&lang=js&"
import style0 from "./addressSort.vue?vue&type=style&index=0&id=cc34e5ec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc34e5ec",
  null
  
)

export default component.exports